import Raven from 'raven-js';
export default Raven;
//# sourceMappingURL=index.js.map